import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import App from "./App.vue"
import router from "./router"
import store from "./store"
// import "normalize.css/normalize.css";
import "./assets/css/iconfont.css"
import VueCookies from "vue-cookies"
import axios from "axios"
// import {WOW} from 'wowjs'
// import animated from 'animate.css'
// import 'wowjs/css/libs/animate.css'
import Vant from "vant"
import "vant/lib/index.css"
import "swiper/js/swiper"
import "swiper/css/swiper.css"
// import 'swiper/dist/js/swiper'
// import 'swiper/dist/css/swiper.css'
import VueLazyload from "vue-lazyload"

Vue.config.productionTip = false
Vue.prototype.axios = axios

// 图片/上传资源域名配置
// 开发环境指向本地后端，生产环境改成实际域名
const domain = process.env.NODE_ENV === "development"
  ? "http://localhost/bm1-backend"
  : window.location.protocol + "//" + window.location.host + "/bm1-backend"
Vue.prototype.domain = domain

Vue.use(ElementUI)
Vue.use(VueCookies)
// Vue.use(animated)
Vue.use(Vant)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 2,
  // 可替换为项目里的占位图
  loading: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
})

router.beforeEach((to, from, next) => {
  let name = "Index"
  let aboutName = ""
  let contactName = ""
  let newsName = ""
  if (to.name === "Index") {
    name = "Index"
  } else if (
    to.name === "About" ||
    to.name === "Culture" ||
    to.name === "Course" ||
    to.name === "Organization" ||
    to.name === "Honor"
  ) {
    name = "About"
  } else if (to.name === "ProjectShow" || /^ProjectPro\d+$/.test(to.name)) {
    name = "ProjectShow"
  } else if (
    to.name === "News" ||
    to.name === "NewsDetail" ||
    to.name === "Industry" ||
    to.name === "Report"
  ) {
    name = "News"
  } else if (
    to.name === "Contact" ||
    to.name === "Relation" ||
    to.name === "JoinUs"
  ) {
    name = "Contact"
  } else if (to.name === "Lvp" || to.name === "Opm") {
    name = "Lvp"
  }
  if (to.name === "About") {
    aboutName = "About"
  } else if (to.name === "Course") {
    aboutName = "Course"
  } else if (to.name === "Culture") {
    aboutName = "Culture"
  } else if (to.name === "Organization") {
    aboutName = "Organization"
  } else if (to.name === "Honor") {
    aboutName = "Honor"
  }
  if (to.name === "Contact") {
    contactName = "Contact"
  } else if (to.name === "Relation") {
    contactName = "Relation"
  } else if (to.name === "JoinUs") {
    contactName = "JoinUs"
  }
  if (to.name === "News") {
    newsName = "News"
  } else if (to.name === "Industry") {
    newsName = "Industry"
  } else if (to.name === "Report") {
    newsName = "Report"
  }
  if (to.name === "Lvp") {
    newsName = "Lvp"
  } else if (to.name === "Opm") {
    newsName = "Opm"
  } else if (to.name === "ProjectPro1") {
    newsName = "pro1"
  } else if (to.name === "ProjectPro2") {
    newsName = "pro2"
  } else if (to.name === "ProjectPro3") {
    newsName = "pro3"
  } else if (to.name === "ProjectPro4") {
    newsName = "pro4"
  } else if (to.name === "ProjectPro5") {
    newsName = "pro5"
  }
  store.state.headNav = name
  store.state.aboutNav = aboutName
  store.state.contactNav = contactName
  store.state.newsNav = newsName

  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0

  next()
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js